import { createFileRoute } from '@tanstack/react-router';

import {
  productEngagementReportQueryOptions,
  productsReportQueryOptions,
  ProductsReportPage,
  productsReportSearchSchema,
  resolveRange,
  todayIn,
  type ProductsReportSearch,
} from '@/features/reports';

export const Route = createFileRoute('/_authed/_active/s/$storeId/reports/products')({
  staticData: { crumb: 'reports:tabs.products', tours: ['reports.products'] },
  validateSearch: productsReportSearchSchema,
  // The engagement sort is not a dep: a header click re-sorts through the page's query (which
  // keeps the previous rows) instead of waiting on the loader. The first load still prefetches it.
  loaderDeps: ({ search }) => ({ range: search.range, from: search.from, to: search.to }),
  loader: ({ context, params, deps, location }) => {
    const range = resolveRange(deps, todayIn(context.store.timezone));
    const { engagementSort } = location.search as ProductsReportSearch;
    return Promise.all([
      context.queryClient
        .query({ ...productsReportQueryOptions(params.storeId, range), staleTime: 'static' })
        .catch(() => undefined),
      context.queryClient
        .query({
          ...productEngagementReportQueryOptions(params.storeId, range, engagementSort),
          staleTime: 'static',
        })
        .catch(() => undefined),
    ]);
  },
  component: ProductsReportPage,
});
